import { User } from "./User";
import { DateUtils } from "../utils/DateUtils";

export class Note {
    id?: number;
    content: string = "";
    _creator?: User;
    created_at?: string;
    updated_at?: string;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["creator"]));
        if (data.creator) {
            this._creator = new User(data.creator);
        }
    }

    get creator(): User {
        return this._creator;
    }

    get creation_date_str(): string {
        return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY - HH[h]mm");
    }
}
